import { changeLogo } from '../../store/logo/logo.actions'
import { dispatch } from '../../application/appStore'
import { getCampaignsFromCampaignManager } from '../../../jsCore/providers/campaignManager/campaignManagerProvider'

export default function initLogoMorph() {
  return getCampaignsFromCampaignManager().then(campaigns =>
    campaigns
      .filter(campaign => campaign.type === 'LogoMorph')
      .forEach(campaign => dispatch(changeLogo(campaign.payload.src)))
  )
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/logoMorphInitializer.js